import React from 'react';

export default function DialogButton({ type = 'primary', children, ...other }) {
  return (
    <button className={`paper popup-dialog__button--${type}`} {...other}>
      {children}
    </button>
  )
}
